// ABOUTME: Formatos de imagen que admite Gemini y recorte centrado de la selfie al más cercano,
// ABOUTME: para que la imagen generada y la selfie coincidan píxel a píxel al componer.
export interface Aspect {
  label: string;
  ratio: number;
}

export const GEMINI_ASPECTS: readonly Aspect[] = [
  { label: "1:1", ratio: 1 },
  { label: "3:4", ratio: 3 / 4 },
  { label: "4:3", ratio: 4 / 3 },
  { label: "2:3", ratio: 2 / 3 },
  { label: "3:2", ratio: 3 / 2 },
  { label: "4:5", ratio: 4 / 5 },
  { label: "5:4", ratio: 5 / 4 },
  { label: "9:16", ratio: 9 / 16 },
  { label: "16:9", ratio: 16 / 9 },
];

export function nearestAspect(width: number, height: number): Aspect {
  const r = width / height;
  return GEMINI_ASPECTS.reduce((best, a) => (Math.abs(Math.log(a.ratio / r)) < Math.abs(Math.log(best.ratio / r)) ? a : best));
}

export function cropToAspect(width: number, height: number, aspect: Aspect): { x: number; y: number; width: number; height: number } {
  const current = width / height;
  if (Math.abs(current - aspect.ratio) < 1e-3) return { x: 0, y: 0, width, height };
  if (current > aspect.ratio) {
    const w = Math.round(height * aspect.ratio);
    return { x: Math.round((width - w) / 2), y: 0, width: w, height };
  }
  const h = Math.round(width / aspect.ratio);
  return { x: 0, y: Math.round((height - h) / 2), width, height: h };
}
